import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.projects;

export default class Projects extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(''),
      managers: this.attr([]),
      add_co_rur: this.number(0),
    };
  }

  static methodConf = {
    http: {
      url: '/catalog/projects',
    },
  };
}
